import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { TrackProvider } from "./hooks/useTrackContext";
import ProductSelectorApp from "./ProductSelectorApp";



const reactProductComponentElement = document.getElementById("react-product");

if (reactProductComponentElement) {
  const root = ReactDOM.createRoot(reactProductComponentElement);

  // This will render the product selector component
  if(reactProductComponentElement.dataset.component === "product-selector"){
    root.render(
      <React.StrictMode>
        <TrackProvider>
          <ProductSelectorApp {...reactProductComponentElement.dataset} />
        </TrackProvider>
      </React.StrictMode>
    );
  }else{
    root.render(
      <React.StrictMode>
        <TrackProvider>
          <App {...reactProductComponentElement.dataset} />
        </TrackProvider>
      </React.StrictMode>
    );

  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
